// extracted by mini-css-extract-plugin
export default {"root":"App_root__nZZtU","App":"App_App__2+VHF","App-logo":"App_App-logo__ZBdRO","App-logo-spin":"App_App-logo-spin__t6jjo"};